import { type DataContainer, submitEvent, trackOnNextPageImpression, submitMerge } from "@otto-ec/tracking-bct";
import { TrackingBackendKeys, type TrackingLabels } from "../types/Websocket";

export class Tracking {

    /**
 *
 *
 */
    trackOnNextPageImpression(trackingData: DataContainer) {
        trackOnNextPageImpression(trackingData);
    }

    /**
 *
 */
    trackSubmitEvent(trackingData: DataContainer) {
        submitEvent(trackingData);
    }

    /*                                                    */
    submitMerge(trackingData: DataContainer) {
        submitMerge(trackingData);
    }
}

export const tracking = new Tracking();
